const state = {
  categories: [],
  categoriesMainList: [],
  newCategory: {},
  categoriesValidate: {},
};

export default state;
